import { Deserializable } from '../../protocols/deserializable';
import { LifeStatus } from '../../types/dto/life-status';
import { LifeStatusIdEnum } from '../../enum/shared/life-status-id.enum';

export class MemberLifeStatus implements Deserializable {
  public id!: number;
  public memberId!: number;
  public lifeStatusId!: LifeStatusIdEnum;
  public lifeStatus!: LifeStatus;
  public effectiveDate!: string;
  public paymentsIssuedToEstate: boolean = false;
  public hasDeathRecord: boolean = false;
  public memberLifeStatusHistory: MemberLifeStatus[] = [];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.lifeStatus) {
      this.lifeStatus = Deserialize.instanceOf(LifeStatus, this.lifeStatus);
    }

    if (this.memberLifeStatusHistory?.length) {
      this.memberLifeStatusHistory = Deserialize.arrayOf(MemberLifeStatus, this.memberLifeStatusHistory);
    }
  }
}
